import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { categories } from "@/mocks/categories";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-20 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-emotion-sad-line text-3xl"></i>
        </span>
        <h1 className="mt-5 font-heading text-2xl tracking-wide text-foreground-950 md:text-4xl">
          这一页好像还没上料
        </h1>
        <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你要找的页面可能被移动或删除了。不如回首页看看今天的爆料，或者从下面的分类里挑一个。
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex h-11 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          回到首页
          <i className="ri-arrow-right-line"></i>
        </Link>
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}